import { message } from "antd";
import { StyledPopover } from "./styles";

const Popconfirm = ({
    trigger = "click",
    className = "",
    arrow = true,
    open,
    defaultOpen,
    children,
    title,
    icon = "",
    description,
    okText = "Yes",
    cancelText = "No",
    placement = "topLeft",
    onConfirm,
    onCancel,
    content,
    cancelButtonProps,
    maskClosable,
    confirmMessage = "", // message for confirm action
    confirmMessageType = "success",
    cancelMessage = "", // message for cancel action
    cancelMessageType = "info",
    ...rest
}) => {
    const [messageApi, messageContextHolder] = message.useMessage();

    const showMessage = (msg, type) => {
        if (typeof msg === "string" && msg.trim()) {
            messageApi.open({ type, content: msg });
        }
    };

    return (
        <StyledPopover
            rootClassName={`${className} custom-confirm-ant`}
            arrow={arrow}
            {...rest}
            icon={icon}
            open={open}
            defaultOpen={defaultOpen}
            title={title}
            okText={okText}
            cancelText={cancelText}
            trigger={trigger}
            description={description || content}
            placement={placement}
            onConfirm={() => {
                if (onConfirm) onConfirm();
                showMessage(confirmMessage, confirmMessageType);
            }}
            onCancel={() => {
                if (onCancel) onCancel();
                showMessage(cancelMessage, cancelMessageType);
            }}
            cancelButtonProps={cancelButtonProps}
            maskClosable={maskClosable}
        >
            {messageContextHolder}
            {children}
        </StyledPopover>
    );
};

export default Popconfirm;
